require( './bootstrap' );

!function (e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}

window.onload = function () {
    if (document.querySelector("#buz-cow")) {
        var e = document.querySelector(".banner"), i = document.querySelector(".footer"),
            t = document.querySelector(".banner__parallax"), o = document.querySelector("#buz-cow");
        t && e.addEventListener("mousemove", function (e) {
            var i = e.clientX, o = e.clientY;
            t.style.webkitTransform = "translateX(" + i / 100 + "%) translateY(" + o / 100 + "%)", t.style.transform = "translateX(" + i / 100 + "%) translateY(" + o / 100 + "%)"
        })
        i.addEventListener("mousemove", function (e) {
            var i = e.clientX, t = e.clientY;
            o.style.webkitTransform = "translateX(" + i / 100 + "%) translateY(" + t / 100 + "%)", o.style.transform = "translateX(" + i / 100 + "%) translateY(" + t / 100 + "%)"
        })
    }
    $("#nav-icon").on("click", function () {
        $(this).toggleClass("open"), $(".mobile-wrapper").toggleClass("open")
    })

    $("body").on("click", ".top", function (e) {
        e.preventDefault();
        var i = $(this).attr("href"), t = $(i).offset().top;
        $("body,html").animate({scrollTop: t}, 1e3)
    })
}
$(document).ready(function () {
    $(".accordion-wrapper__item .title").on("click", function () {
        return $(".accordion-wrapper__item .accordion-content").slideUp(), $(this).hasClass("open") ? ($(".accordion-wrapper__item .title").removeClass("open"), !1) : ($(".accordion-wrapper__item .title").removeClass("open"), $(this).addClass("open"), $(this).next().slideDown(), !1)
    })
})
jQuery("img.svg").each(function () {
    var e = jQuery(this), i = e.attr("id"), t = e.attr("class"), o = e.attr("src");
    jQuery.get(o, function (o) {
        var s = jQuery(o).find("svg");
        void 0 !== i && (s = s.attr("id", i)), void 0 !== t && (s = s.attr("class", t + " replaced-svg")), s = s.removeAttr("xmlns:a"), e.replaceWith(s)
    }, "xml")
})

$(document).on("scroll", function () {
    var e = $(window).scrollTop(), i = $("#top-cloud"), t = $("#bottom-cloud"), o = .3 * e;
    i.css("transform", "translateY(-" + o + "px) translateZ(0)"), i.css("-webkit-transform", "translateY(-" + o + "px) translateZ(0)"), t.css("transform", "translateY(-" + o + "px) translateZ(0)"), t.css("-webkit-transform", "translateY(-" + o + "px) translateZ(0)")
});

function addClass(e, i) {
    e.classList ? e.classList.add(i) : e.className += " " + i
}

function removeClass(e, i) {
    e.classList ? e.classList.remove(i) : e.className = e.className.replace(new RegExp("(^|\\b)" + i.split(" ").join("|") + "(\\b|$)", "gi"), " ")
}

function hasClass(e, i) {
    var t = !1;
    return e.classList ? e.classList.contains(i) && (t = !0) : new RegExp("(^| )" + i + "( |$)", "gi").test(e.className) && (t = !0), t
}

function toggleClass(e, i) {
    if (e.classList) e.classList.toggle(i); else {
        var t = e.className.split(" "), o = t.indexOf(i);
        o >= 0 ? t.splice(o, 1) : t.push(i), e.className = t.join(" ")
    }
}

function _coverTable() {
  var table = document.querySelectorAll('table');
  for (var i = table.length - 1; i >= 0; i--) {
    var cover = document.createElement('div');
    cover.classList.add('cover-table');
    table[i].parentNode.insertBefore(cover, table[i]);
    cover.appendChild(table[i]);
  }
}

_coverTable();

(function(){
    'use strict';
    //--------------------------------------------------------------------------------------------------------------
    //	LOAD IFRAME GAME
    //--------------------------------------------------------------------------------------------------------------
    (function(){
        var wrap = document.getElementById('js_game');
        if (wrap){
            loadGame();
        }

        function loadGame(){
            var btn = wrap.getElementsByTagName('button')[0];
            if (btn){
                btn.addEventListener('click', loadFrame);
            }

            function loadFrame(){
                var frame = document.createElement('iframe'),
                    src = wrap.getAttribute('data-game');

                frame.setAttribute('src', src);
                btn.removeEventListener('click', loadFrame);
                wrap.innerHTML = '';
                wrap.appendChild(frame);
            }
        }
    })();
})();
